import { useCallback, useRef, useState } from "react";

/**
 * Chat state for one application page.
 *
 * The agent backend does not exist yet, so nothing is sent anywhere: this only drives the
 * conversation UI, and the reply is a fixed placeholder that says so. Swap `respond()` for a
 * real API call once the endpoint lands — the rest of the page needs no change.
 */
const PLACEHOLDER_REPLY =
  "هنوز به ایجنت متصل نشده‌ام. این صفحه در حال حاضر فقط طراحی گفت‌وگوست و پیام‌ها به سروری ارسال نمی‌شوند. به‌محض آماده شدن سرویس ایجنت، پاسخ واقعی همین‌جا نمایش داده می‌شود.";

let nextId = 1;

function createMessage(role, content) {
  return { id: nextId++, role, content, at: new Date() };
}

export default function useAgentChat() {
  const [messages, setMessages] = useState([]);
  const [pending, setPending] = useState(false);
  const timerRef = useRef(null);

  const send = useCallback(
    (text) => {
      const content = text.trim();
      if (!content || pending) {
        return;
      }

      setMessages((current) => [...current, createMessage("user", content)]);
      setPending(true);

      // A short delay so the typing indicator is visible — it is presentation, not a request.
      timerRef.current = setTimeout(() => {
        setMessages((current) => [...current, createMessage("agent", PLACEHOLDER_REPLY)]);
        setPending(false);
      }, 700);
    },
    [pending]
  );

  const reset = useCallback(() => {
    clearTimeout(timerRef.current);
    setMessages([]);
    setPending(false);
  }, []);

  return { messages, pending, send, reset };
}
